__webpack_require__.p = "https://eagleeye-gamma.na.aftx.amazonoperations.app/";